import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchDigitalForms(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('operation/digital-form', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchDigitalForm(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`operation/digital-form/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteDigitalForm(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`operation/digital-form/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
